// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3GXE5","sendOtp":"AuthorizeToLogin_sendOtp__1iKt8"};